import {
  browserTracingIntegration,
  httpClientIntegration,
} from '@sentry/browser';
import { NodeOptions, EventHint } from '@sentry/nextjs';

import { posthog } from '@/posthog';

const unhandledMatchers = [
  /Failed to fetch/i,
  /NetworkError/i,
  /ztag/i,
  /gmo/i,
];

export const SHARED_SENTRY_CONFIG: NodeOptions = {
  allowUrls: [/.*\.?join1440\.com/],
  debug: false,
  dsn: 'https://c516dbc259ea3bd46f382f5494465cb9@o4506299638087680.ingest.sentry.io/4506633764077568',
  enabled: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production',
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV,
  tracesSampleRate: 0.1,

  integrations: [
    httpClientIntegration(),
    browserTracingIntegration(),
    posthog.sentryIntegration({
      organization: '1440',
      projectId: 67012,
      severityAllowList: ['error', 'info'],
    }),
  ],

  beforeSend(event, hint: EventHint) {
    const error = hint.originalException as Error;

    if (hint?.mechanism?.type === 'onunhandledrejection') {
      event.extra = { ...event.extra, fetchError: true };
      event.tags = { ...event.tags, fetchError: true };

      unhandledMatchers.forEach((i) => {
        const msg = `${error.message + error.stack}`;
        if (msg.match(i)) {
          return;
        } else {
          event.fingerprint = ['unknown-client-network-failure'];
        }
      });
    }

    // We should only report if the error a SERVER SIDE exception
    // we should _not_ be asking for reports from latent client side issues
    // caused by side loading of ads
    // if (event.exception && event.event_id) {
    // showReportDialog({ eventId: event.event_id });
    // }

    return event;
  },

  ignoreErrors: [
    // Meta Browser Errors
    'AutoFillPopupClose',
    'AutofillCallbackHandler',

    // Crypto error that occurs via getangler.ai via GTM
    'crypto.randomUUID',

    // PostHog
    'Non-Error promise rejection captured with value: Timeout',
    'value: Timeout',

    // Algolia flakes
    'Unreachable hosts',

    // React Error in older browsers
    'Unknown root',

    // new KH deploy
    'undefined is not an object',
    "Cannot destructure property.*message'",
    'runtime.sendMessage',
    'The operation is insecure.',
    'There is no clipping info for given tab',
    'Java bridge method',
    'The user aborted a request',
    "Unexpected token 'else'",
    'WKWebView',
    'Uncaught, unspecified',
    'transporterStackTrace',
    'Non-Error promise rejection captured',
    'object Object',
    'anglerai',
    'Right side of assignment',
    'querySelectorAll',
    'Importing a module script failed',
    'TypeError: Failed to fetch',
    `ReferenceError: can't find variable: gmo`,
    `Can't find variable: gmo`,
    `IndexSizeError`,
    `Java exception was raised during method invocation`,
    /Unknown root exit status/,
  ],
};
